import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Hero } from 'Components/widgets/hero/Hero';
type Props = {
  alt: string;
  className?: string;
  immersiveSize?: ImmersiveSizeProps;
  isImmersive?: boolean;
  src: string;
};
export const ImmersiveSlideShowItem = ({
  alt,
  className,
  immersiveSize = 'large',
  isImmersive = false,
  src,
}: Props) => (
  <div className={classnames('relative', className)} key={src}>
    <Hero alt={alt} isImmersive={isImmersive} size={immersiveSize} url={src} />
  </div>
);
